import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, TablePagination, Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, List as MuiList, ListItem, ListItemText, Tabs, Tab, Chip, Alert, Snackbar, Menu, MenuItem, TableSortLabel, FormControlLabel, Checkbox, TextField as MuiTextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { tgUserAPI } from '../../Api';
import PlumSvg from '../component/PlumSvg'; // Если у вас есть этот компонент

import { TextField } from '@mui/material';

const List =  () => {
  // State for orders popup
  const [ordersDialogOpen, setOrdersDialogOpen] = useState(false);
  const [selectedUserOrders, setSelectedUserOrders] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  // Состояния для данных пользователей и пагинации
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0); // В TablePagination page начинается с 0
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0); // всего записей на сервере
  const [search, setSearch] = useState(''); // значение поиска
  const [editBalanceId, setEditBalanceId] = useState(null); // id пользователя для редактирования баланса
  const [editBalanceValue, setEditBalanceValue] = useState('');
  // Новые состояния для вкладок
  const [activeTab, setActiveTab] = useState(0); // 0 - все пользователи, 1 - неактивные с балансом
  // Состояния для бана
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  // Состояния для сортировки
  const [orderBy, setOrderBy] = useState('created_at');
  const [order, setOrder] = useState('desc');
  // Фильтр для заблокированных
  const [showOnlyBanned, setShowOnlyBanned] = useState(false);
  // Диалог редактирования метаданных (orders/comment)
  const [metaDialogOpen, setMetaDialogOpen] = useState(false);
  const [metaOrders, setMetaOrders] = useState(5);
  const [metaComment, setMetaComment] = useState('');
  // Общая сумма балансов неактивных пользователей
  const [totalBalance, setTotalBalance] = useState(0);

  // Обработчик изменения поля поиска
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    // Здесь можно реализовать фильтрацию
  };

  // Открыть диалог редактирования метаданных
  const handleOpenMetaDialog = (user) => {
    setSelectedUser(user);
    setMetaOrders(typeof user.ordersLimit === 'number' ? user.ordersLimit : (typeof user.orders === 'number' ? user.orders : 5));
    setMetaComment(user.comment || '');
    setMetaDialogOpen(true);
  };
  const handleCloseMetaDialog = () => {
    setMetaDialogOpen(false);
    setSelectedUser(null);
  };
  const handleSaveMeta = async () => {
    if (!selectedUser) return;
    let ordersVal = Number(metaOrders);
    if (Number.isNaN(ordersVal) || ordersVal < 0) ordersVal = 0;
    if (ordersVal > 5) ordersVal = 5;
    try {
      await tgUserAPI.editUserMeta(selectedUser._id, ordersVal, metaComment);
      setSnackbar({ open: true, message: 'Данные пользователя обновлены', severity: 'success' });
      // Оптимистично обновим локальный список, чтобы число сразу поменялось
      setUsers(prev => prev.map(u => u._id === selectedUser._id ? { ...u, ordersLimit: ordersVal, comment: metaComment } : u));
      handleCloseMetaDialog();
    } catch (e) {
      setSnackbar({ open: true, message: 'Ошибка обновления данных', severity: 'error' });
    }
  };
  useEffect(() => {
    if (activeTab === 0) {
      fetchUsers(page, rowsPerPage, search);
    } else {
      fetchInactiveUsers(page, rowsPerPage);
    }
    // eslint-disable-next-line
  }, [page, rowsPerPage, search, activeTab]);

  const editBalSave = async () => {
    try {
        await tgUserAPI.editUserBalance(editBalanceId, editBalanceValue);
        setEditBalanceId(null);
        setEditBalanceValue('');
        // Обновляем данные в зависимости от активной вкладки
        if (activeTab === 0) {
          fetchUsers(page, rowsPerPage, search);
        } else {
          fetchInactiveUsers(page, rowsPerPage);
        }
    } catch (error) {
        console.error('Error editing balance:', error);
    }
  }

  // Обработчики для бана
  const handleBanUser = async (userId) => {
    try {
      await tgUserAPI.banUser(userId);
      setSnackbar({ open: true, message: 'Пользователь заблокирован', severity: 'success' });
      if (activeTab === 0) {
        fetchUsers(page, rowsPerPage, search);
      } else {
        fetchInactiveUsers(page, rowsPerPage);
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'Ошибка блокировки пользователя', severity: 'error' });
    }
    handleCloseActionMenu();
  };

  const handleUnbanUser = async (userId) => {
    try {
      await tgUserAPI.unbanUser(userId);
      setSnackbar({ open: true, message: 'Пользователь разблокирован', severity: 'success' });
      if (activeTab === 0) {
        fetchUsers(page, rowsPerPage, search);
      } else {
        fetchInactiveUsers(page, rowsPerPage);
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'Ошибка разблокировки пользователя', severity: 'error' });
    }
    handleCloseActionMenu();
  };

  const handleOpenActionMenu = (event, user) => {
    setActionMenuAnchor(event.currentTarget);
    setSelectedUser(user);
  };

  const handleCloseActionMenu = () => {
    setActionMenuAnchor(null);
    setSelectedUser(null);
  };

  // Обработчик сортировки
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // Функция сортировки и фильтрации
  const sortedUsers = React.useMemo(() => {
    // Сначала фильтруем
    let filtered = [...users];
    if (showOnlyBanned) {
      filtered = filtered.filter(user => user.banned === true);
    }
    
    // Затем сортируем
    const comparator = (a, b) => {
      if (orderBy === 'banned') {
        const aVal = a.banned ? 1 : 0;
        const bVal = b.banned ? 1 : 0;
        return order === 'asc' ? aVal - bVal : bVal - aVal;
      }
      if (orderBy === 'balance') {
        return order === 'asc' ? a.balance - b.balance : b.balance - a.balance;
      }
      if (orderBy === 'created_at') {
        const aDate = new Date(a.created_at).getTime();
        const bDate = new Date(b.created_at).getTime();
        return order === 'asc' ? aDate - bDate : bDate - aDate;
      }
      return 0;
    };
    return filtered.sort(comparator);
  }, [users, order, orderBy, showOnlyBanned]);

  // Обработчик смены вкладки
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPage(0); // Сбрасываем на первую страницу
    setSearch(''); // Очищаем поиск при смене вкладки
  };
  // Получение пользователей с сервера с учетом пагинации
  const fetchUsers = async (page, limit, search) => {
    try {
      // API ожидает два числа, а не объект
      const pageNum = Number(page) + 1;
      const limitNum = Number(limit);
      const response = await tgUserAPI.getTgUsers(pageNum, limitNum, search);
      
      // Проверяем что данные корректные
      if (response.data && response.data.success) {
        const userData = response.data.data || [];
        const pagination = response.data.pagination || { total: 0 };
        
        if (Array.isArray(userData)) {
          const mapped = userData.map(u => ({
            ...u,
            ordersLimit: typeof u.orders === 'number' ? u.orders : (typeof u.ordersLimit === 'number' ? u.ordersLimit : 5),
          }));
          setUsers(mapped);
          setTotal(pagination.total);
        } else {
          console.error('Regular users data is not an array:', userData);
          setUsers([]);
          setTotal(0);
        }
      } else {
        console.error('Invalid response format for regular users:', response.data);
        setUsers([]);
        setTotal(0);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
      setTotal(0);
    }
  };

  // Получение неактивных пользователей с балансом
  const fetchInactiveUsers = async (page, limit) => {
    try {
      const pageNum = Number(page) + 1;
      const limitNum = Number(limit);
      const response = await tgUserAPI.getInactiveUsers(pageNum, limitNum);
      console.log('Inactive users response:', response.data);
      
      // Проверяем что данные корректные
      if (response.data && response.data.success) {
        const userData = response.data.data || [];
        const pagination = response.data.pagination || { total: 0 };
        const totalBal = response.data.totalBalance || 0;
        
        console.log('Setting users:', userData, 'type:', typeof userData, 'isArray:', Array.isArray(userData));
        console.log('Total balance:', totalBal);
        
        if (Array.isArray(userData)) {
          const mapped = userData.map(u => ({
            ...u,
            ordersLimit: typeof u.orders === 'number' ? u.orders : (typeof u.ordersLimit === 'number' ? u.ordersLimit : 5),
          }));
          setUsers(mapped);
          setTotal(pagination.total);
          setTotalBalance(totalBal);
        } else {
          console.error('userData is not an array:', userData);
          setUsers([]);
          setTotal(0);
          setTotalBalance(0);
        }
      } else {
        console.error('Invalid response format:', response.data);
        setUsers([]);
        setTotal(0);
        setTotalBalance(0);
      }
    } catch (error) {
      console.error('Error fetching inactive users:', error);
      setUsers([]);
      setTotal(0);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  // Сохранение баланса (вызывается при blur или Enter)
  const handleBalanceSave = (userId) => {
    // Здесь можно сделать API-запрос для обновления баланса
    setUsers(prev => prev.map(u =>
      u._id === userId ? { ...u, balance: editBalanceValue } : u
    ));
    setEditBalanceId(null);
    editBalSave();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "WAIT_PAY_LINK":
        return 'orange';
      case "WAIT_PAY":
        return 'yellow';
      case "PAID":
        return 'green';
      case "FAILED":
        return 'red';
      default:
        return 'black';
    }
  };
  return (
    <>
      {/* Orders Dialog */}
      <Dialog open={ordersDialogOpen} onClose={() => setOrdersDialogOpen(false)} maxWidth="xl" fullWidth>
        <DialogTitle>Ордера пользователя {selectedUserId}</DialogTitle>
        <DialogContent sx={{ minWidth: 900 }}>
          {selectedUserOrders && selectedUserOrders.length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Ордер ИД</TableCell>
                    <TableCell>Мерчант</TableCell>
                    <TableCell>Сумма</TableCell>
                    <TableCell>Статус</TableCell>
                    <TableCell>Создан</TableCell>
                    <TableCell>Оплачен</TableCell>
                    <TableCell>Истекает</TableCell>
                    <TableCell>Метод оплаты</TableCell>
                    <TableCell>Тип</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedUserOrders.map((order, idx) => (
                    <TableRow key={order._id || idx}>
                      <TableCell>{order.order_id}</TableCell>
                      <TableCell>{order.merchant_id?.name || 'Неизвестно'}</TableCell>
                      <TableCell>{order?.amount} ({order.total_amount})</TableCell>
                      <TableCell sx={{ color: getStatusColor(order.status) }}>{order.status}</TableCell>
                      <TableCell>{order.created_at ? new Date(order.created_at).toLocaleString('ru-RU') : '-'}</TableCell>
                      <TableCell>{order.paid_at ? new Date(order.paid_at).toLocaleString('ru-RU') : '-'}</TableCell>
                      <TableCell>{order.expired_at ? new Date(order.expired_at).toLocaleString('ru-RU') : '-'}</TableCell>
                      <TableCell>{order.payment_method || '-'}</TableCell>

                      <TableCell>{order.type || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography color="text.secondary">Нет ордеров</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOrdersDialogOpen(false)}>Закрыть</Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: "#fefcfb" }}>
        <Typography variant="h5" align="center" gutterBottom>
       Telegram Пользователи
      </Typography>
      
      {/* Вкладки */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="user tabs">
          <Tab 
            label="Все пользователи" 
            icon={<AccountBalanceWalletIcon />} 
            iconPosition="start"
          />
          <Tab 
            label="Неактивные с балансом" 
            icon={<AccessTimeIcon />} 
            iconPosition="start"
          />
        </Tabs>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {activeTab === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Пользователи с балансом больше 0, неактивные более 7 дней
              </Typography>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                backgroundColor: '#f3f6fa',
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #d0d7de'
              }}>
                <AccountBalanceWalletIcon color="primary" />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                  Общая сумма: {totalBalance.toLocaleString('ru-RU')} ₽
                </Typography>
              </Box>
            </Box>
          )}
          {activeTab === 0 && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={showOnlyBanned}
                  onChange={(e) => setShowOnlyBanned(e.target.checked)}
                  color="error"
                />
              }
              label="Только заблокированные"
            />
          )}
        </Box>
        {activeTab === 0 && (
          <TextField
            label="Поиск по TG ID"
            variant="outlined"
            size="small"
            value={search}
            onChange={handleSearchChange}
            sx={{ minWidth: 240 }}
          />
        )}
      </Box>
      <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
        <Table
          sx={{
            borderCollapse: 'collapse',
            minWidth: 650,
            fontFamily: 'Segoe UI, Arial, sans-serif',
          }}
          aria-label="excel style table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >TG ID</TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >
                <TableSortLabel
                  active={orderBy === 'balance'}
                  direction={orderBy === 'balance' ? order : 'asc'}
                  onClick={() => handleRequestSort('balance')}
                >
                  Баланс
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >
                <TableSortLabel
                  active={orderBy === 'banned'}
                  direction={orderBy === 'banned' ? order : 'asc'}
                  onClick={() => handleRequestSort('banned')}
                >
                  Статус
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >
                <TableSortLabel
                  active={orderBy === 'created_at'}
                  direction={orderBy === 'created_at' ? order : 'asc'}
                  onClick={() => handleRequestSort('created_at')}
                >
                  Дата регистрации
                </TableSortLabel>
              </TableCell>
              {activeTab === 1 && (
                <TableCell
                  sx={{
                    fontWeight: 'bold',
                    color: '#222',
                    backgroundColor: '#f3f6fa',
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >Последняя активность</TableCell>
              )}
              {activeTab === 1 && (
                <TableCell
                  sx={{
                    fontWeight: 'bold',
                    color: '#222',
                    backgroundColor: '#f3f6fa',
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >Дней неактивен</TableCell>
              )}
                   <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >Ордеры</TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >Лимит ордеров</TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >Комментарий</TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  color: '#222',
                  backgroundColor: '#f3f6fa',
                  border: '1px solid #d0d7de',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  padding: '8px',
                }}
              >Действия</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedUsers.map((user, idx) => (
              <TableRow
                key={user._id}
                sx={{
                  backgroundColor: idx % 2 === 0 ? '#fff' : '#f9fbfd',
                  '&:hover': {
                    backgroundColor: '#e3f0ff',
                  },
                }}
              >
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >{user.userId}</TableCell>
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setEditBalanceId(user._id);
                    setEditBalanceValue(user.balance);
                  }}
                >
                  {editBalanceId === user._id ? (
                    <input
                      type="number"
                      autoFocus
                      value={editBalanceValue}
                      style={{ width: '80px', fontSize: '1rem', fontFamily: 'inherit', padding: '2px 6px' }}
                      onChange={e => setEditBalanceValue(e.target.value)}
                      onBlur={() => handleBalanceSave(user._id)}
                      onKeyDown={e => {
                        if (e.key === 'Enter') handleBalanceSave(user._id);
                        if (e.key === 'Escape') setEditBalanceId(null);
                      }}
                    />
                  ) : (
                    user.balance
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >
                  {user.banned ? (
                    <Chip 
                      icon={<BlockIcon />}
                      label="Заблокирован" 
                      color="error" 
                      size="small"
                    />
                  ) : (
                    <Chip 
                      icon={<CheckCircleIcon />}
                      label="Активен" 
                      color="success" 
                      size="small"
                    />
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >{user.created_at}</TableCell>
                {activeTab === 1 && (
                  <TableCell
                    sx={{
                      border: '1px solid #d0d7de',
                      fontFamily: 'Segoe UI, Arial, sans-serif',
                      padding: '8px',
                    }}
                  >
                    {user.lastActivityFormatted || 'Неизвестно'}
                  </TableCell>
                )}
                {activeTab === 1 && (
                  <TableCell
                    sx={{
                      border: '1px solid #d0d7de',
                      fontFamily: 'Segoe UI, Arial, sans-serif',
                      padding: '8px',
                    }}
                  >
                    <Chip 
                      label={`${user.daysInactive || 0} дней`}
                      color={user.daysInactive > 30 ? 'error' : user.daysInactive > 14 ? 'warning' : 'default'}
                      size="small"
                    />
                  </TableCell>
                )}
                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      setSelectedUserOrders(user.ordersList || user.orders || []);
                      setSelectedUserId(user.userId);
                      setOrdersDialogOpen(true);
                    }}
                  >Посмотреть ордера</Button>
                </TableCell>
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >{typeof user.ordersLimit === 'number' ? user.ordersLimit : 5}</TableCell>
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                    maxWidth: 260,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                  title={user.comment || ''}
                >{user.comment || '-'}</TableCell>
                <TableCell
                  sx={{
                    border: '1px solid #d0d7de',
                    fontFamily: 'Segoe UI, Arial, sans-serif',
                    padding: '8px',
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={(e) => handleOpenActionMenu(e, user)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            "& .MuiTablePagination-select": {
              color: "#683d62",
            },
            "& .MuiTablePagination-toolbar": {
              backgroundColor: "#fefcfb",
            },
            "& .MuiTablePagination-spacer": {
              display: 'none',
            },
            "& .MuiTablePagination-actions": {
              color: "#683d62",
            },
          }}
        />
      </TableContainer>
    </Box>

    {/* Action Menu */}
    <Menu
      anchorEl={actionMenuAnchor}
      open={Boolean(actionMenuAnchor)}
      onClose={handleCloseActionMenu}
    >
      {selectedUser && !selectedUser.banned && (
        <MenuItem onClick={() => handleBanUser(selectedUser.userId)}>
          <BlockIcon fontSize="small" sx={{ mr: 1 }} />
          Заблокировать
        </MenuItem>
      )}
      {selectedUser && selectedUser.banned && (
        <MenuItem onClick={() => handleUnbanUser(selectedUser.userId)}>
          <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />
          Разблокировать
        </MenuItem>
      )}
      {selectedUser && (
        <MenuItem onClick={() => { handleCloseActionMenu(); handleOpenMetaDialog(selectedUser); }}>
          <EditIcon fontSize="small" sx={{ mr: 1 }} />
          Редактировать
        </MenuItem>
      )}
    </Menu>

    {/* Snackbar для уведомлений */}
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={() => setSnackbar({ ...snackbar, open: false })}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert 
        onClose={() => setSnackbar({ ...snackbar, open: false })} 
        severity={snackbar.severity}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>

    {/* Диалог редактирования orders/comment */}
    <Dialog open={metaDialogOpen} onClose={handleCloseMetaDialog} maxWidth="sm" fullWidth>
      <DialogTitle>Редактирование пользователя</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <MuiTextField
            label="Лимит ордеров (0-5)"
            type="number"
            value={metaOrders}
            onChange={(e) => {
              const v = Number(e.target.value);
              if (Number.isNaN(v)) setMetaOrders(0);
              else setMetaOrders(Math.max(0, Math.min(5, v)));
            }}
            inputProps={{ min: 0, max: 5 }}
            size="small"
          />
          <MuiTextField
            label="Комментарий"
            multiline
            minRows={2}
            value={metaComment}
            onChange={(e) => setMetaComment(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseMetaDialog}>Отмена</Button>
        <Button onClick={handleSaveMeta} variant="contained">Сохранить</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default List;
